import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  cursor: pointer;\n  height: ", ";\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  width: ", ";\n\n  &:focus {\n    + div {\n      outline: ", " dashed\n        ", ";\n      outline-offset: ", ";\n      ", ";\n    }\n\n    &:not(:hover) + div > span {\n      &::after {\n        ", ";\n      }\n    }\n  }\n\n  &:hover + div {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
export var propTypes = {
  /**
   * @ignore
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object
};
export var defaultProps = {
  focusState: false,
  selected: false,
  colorConfig: colors
};
/**
 * @ignore
 */

var ColorInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "ColorInput",
  componentId: "sc-2pi1pt-0"
})(_templateObject(), function (_ref) {
  var size = _ref.size;
  return calculateRem(size);
}, function (_ref2) {
  var size = _ref2.size;
  return calculateRem(size);
}, calculateRem(1), function (_ref3) {
  var colorConfig = _ref3.colorConfig;
  return colorConfig.black;
}, calculateRem(2), function (_ref4) {
  var focusState = _ref4.focusState;
  return focusState && "\n          outline: none;\n        ";
}, function (_ref5) {
  var focusState = _ref5.focusState,
      focusSize = _ref5.focusSize,
      size = _ref5.size,
      colorConfig = _ref5.colorConfig;
  return focusState && "\n            background: transparent;\n            // background: orange;\n            border: ".concat(calculateRem(1), " dashed ").concat(colorConfig.black, ";\n            border-radius: 50%;\n            box-sizing: border-box;\n            content: '';\n            height: ").concat(focusSize(size - 1), ";\n            left: 50%;\n            position: absolute;\n            top: 50%;\n            transform: translate(-50%, -50%);\n            width: ").concat(focusSize(size - 1), ";\n          ");
});
ColorInput.propTypes = propTypes;
ColorInput.defaultProps = defaultProps;
export default ColorInput;